import type { WorkspacePackageData } from '@apiTypes'

export const PackageQuotaFlag = {
  Tender: 'tenderEnabled',
  ContractMatching: 'contractMatchingEnabled',
} as const satisfies Record<string, keyof WorkspacePackageData>

export type PackageQuotaFlag = (typeof PackageQuotaFlag)[keyof typeof PackageQuotaFlag]
